import { store } from "../store";
export default class Utilerias {
    
    getFechaWCF(fecha,hora){
        if(fecha){
            var millis = fecha
            .replace("/Date(","")
            .replace("/","")
            .replace(")","");           
            
            millis = millis * 1;


            if(millis>0){  
            var mfecha = new Date(millis);
        
            var res = mfecha.getDate() < 10 ? "0" + mfecha.getDate(): mfecha.getDate();
            res+="/";
            res+=(mfecha.getMonth() + 1) < 10 ? "0" + (mfecha.getMonth() + 1):(mfecha.getMonth() + 1);
            res+="/";
            res+=mfecha.getFullYear();


            if(hora){
                res+=" ";
                res+=(mfecha.getHours());
                res+=":"
                res+=mfecha.getMinutes() < 10 ? "0" + mfecha.getMinutes(): mfecha.getMinutes();
            }


            return res;
            }
            else{        
            return "N/D";
            }
        }
    }


    getFechaWCFDate(fecha, hora) {
        if (fecha) {
            var millis = fecha
                .replace("/Date(", "")
                .replace("/", "")
                .replace(")", "");
    
            millis = millis * 1;
    
            if (millis > 0) {
                var mfecha = new Date(millis);
    
                if (hora) {
                    return mfecha;
                }
    
                return new Date(
                    mfecha.getFullYear(),
                    mfecha.getMonth(),
                    mfecha.getDate()
                );
            } else {
                return null; 
            }
        }
        return null; 
    }


    getDateFromWCF(fecha){
        if(fecha){
            var millis = fecha
            .replace("/Date(","")
            .replace("/","")
            .replace(")","");           
            
            millis = millis * 1;


            if(millis>0){  
                var mfecha = new Date(millis);
                return mfecha;
            }


        }
        
        return null;
    }


    formateaFechaAMD(fecha){
            
        var anio = fecha.getFullYear();
        var mes = fecha.getMonth() + 1;
        var dia = fecha.getDate();


        return anio + "-" + mes + "-" + dia;
        
    }


    formateaFechaDATE(fecha) {
        if (!fecha || !(fecha instanceof Date)) {
            return null;
        }
        return "/Date(" + fecha.getTime() + ")/";
    }




    formatNumber(value) {
        if(value){                              
            return new Intl.NumberFormat('es-MX').format(value);
        }
        else
            return 0;
    }


    formatCurrency(value) {
        if(value){              
            var formatter = new Intl.NumberFormat('es-MX'
            // , {
            //     style: 'currency',
            //     currency: '$',                   
            //    }
                );
            return formatter.format(value);
        }
        else
            return 0;
    }


    dateToString(fecha){


        // Extraer el año, mes y día de la fecha
        var anio = fecha.getFullYear();
        var mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // +1 porque los meses van de 0 a 11
        var dia = fecha.getDate().toString().padStart(2, '0');


        // Formatear la fecha en el formato "yyyy-MM-dd"
        return anio + '-' + mes + '-' + dia;
    }


    eliminarObjetosRepetidos(array){
        const setObj = new Set(); // creamos pares de clave y array
        const unicos = array.reduce((acc, obj) => {
        const clave = JSON.stringify(obj);
        
        if (!setObj.has(clave)){
            setObj.add(clave, obj)
            acc.push(obj)
        }
        return acc;
        },[]);


        return unicos;
    }


    getEstatus(id){
        let statusList = [
                {Id: 0, Label:  "Indefinido"},
                {Id: 1, Label:  "Creado"},
                {Id: 2, Label:  "Aceptado"},
                {Id: 3, Label:  "Validado"},
                {Id: 4, Label:  "Rechazado"},
                {Id: 5, Label:  "Capturado_PREI"},
                {Id: 6, Label:  "Complementado"},
                {Id: 7, Label:  "Reportado"},
                {Id: 8, Label:  "Finalizado"},
                {Id: 9, Label:  "Cancelado"},
                {Id: 10, Label: "Activo"},
                {Id: 11, Label: "Inactivo"},
                {Id: 12, Label: "Prestado"},
                {Id: 13, Label: "Devuelto"},
        ]
        let status = statusList.find(x =>  x.Id === id);
        return status ? status.Label : id;
    }

    getEstatusSalidasEquipos(id){
        let statusList = [
                {Id: 10, label:  "Activo", severity: "success"},
                {Id: 9, label:  "Cancelado", severity: "warning"},
        ]
        let status = statusList.find(x =>  x.Id === id);
        return status ? status : statusList[0];
    }
    


    isPermiso(permisoString = null){
        let user = store.getters.getUsuarioLogueado;
        let isPermiso = false;
        let permiso = user?.Usuario_sistema_permisos?.find(p => p.Permiso == permisoString);
        if(permiso ){
            let value = JSON.parse(permiso.Valor);
            isPermiso = value?.Permiso?? false;
            return isPermiso;
        }else{
            return null;
        }
    }


    isCategoria(categoriaString){
        let user = store.getters.getUsuarioLogueado;
        let categoria = user?.Empleado_ci?.Puesto;
        if(categoria ){
            return categoria == categoriaString;
        }else{
            return null;
        }
    }
    isAdmin(){
        return store.getters.getUsuarioLogueado?.Usuario_sistema?.Id_sistema == 4 && store.getters.getUsuarioLogueado?.Usuario_sistema?.Id_rol == 1;
    }


    isAdminTelecom(){
        return store.getters.getUsuarioLogueado?.Usuario_sistema?.Id_sistema == 4 && store.getters.getUsuarioLogueado?.Usuario_sistema?.Id_rol == 2
    }

    esNumero(cadena) {
        // Elimina espacios en blanco al principio y al final
        const cadenaLimpia = cadena.trim();
        
        // Verifica si la cadena está vacía después de limpiarla
        if (cadenaLimpia === '') {
            return null;
        }
        
        // Intenta convertir la cadena a número
        const numero = Number(cadenaLimpia);
        
        // Verifica si el resultado no es NaN y que la cadena original coincide con el número
        // Esto evita casos como "123abc" que Number() convertiría a NaN
        if (!isNaN(numero) && cadenaLimpia === numero.toString()) {
            return numero;
        }
        
        // Verifica números con decimales (por si el toString() no coincide exactamente)
        if (!isNaN(numero) && !isNaN(parseFloat(cadenaLimpia))) {
            return numero;
        }
        
        return null;
    }

    limpiarCadena(cadena) {
        if (typeof cadena !== 'string') {
            return null;
        }
        const cadenaNormalizada = cadena.normalize("NFD");

        const sinAcentos = cadenaNormalizada.replace(/[\u0300-\u036f]/g, "");

        const limpiaYMinusculas = sinAcentos
            .replace(/[^a-zA-Z0-9]/g, '') // Ya no se permite \s (espacios)
            .toLowerCase();

        return limpiaYMinusculas;
    }
    
}